export class AllocationRequestAccumulationType {
	constructor() {
	}
} 
